import axios from 'CanExConfig/axios'

const endpoint = candidateProfileId => `/api/candidate/v2/candidate_profiles/${candidateProfileId}/job_preferences`

export const getJobPreferences = async candidateProfileId => {
  const response = await axios(endpoint(candidateProfileId), {
    method: 'GET',
  })

  return response.data
}

export const patchJobPreferences = async (candidateProfileId, data) => {
  const response = await axios(endpoint(candidateProfileId), {
    method: 'PATCH',
    data,
  })

  return response.data
}
